// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__2GDNH","actionColumn":"ReferralSources_actionColumn__tjd-f","textButton":"ReferralSources_textButton__2H8lV"};